import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function MailOpened(props) {
    return (
        <SvgIcon {...props}>
            <path
                d="M30.1 9.8L17.8 1.2c-1-.7-2.3-.7-3.3 0L1.9 9.7C.8 10.4.4 11.8.8 13l3.6 11.2c.4 1.2 1.5 2 2.8 2l17.8.5h.1c1.3 0 2.5-.9 2.8-2.1L31.2 13c.4-1.2-.1-2.5-1.1-3.2z"
                fill="#ef7109"
            />
            <path
                d="M5.4 2.8h21.1c1.3 0 2.4 1.1 2.4 2.4V21c0 1.3-1.1 2.4-2.4 2.4H5.4C4.1 23.3 3 22.3 3 21V5.2c0-1.3 1.1-2.4 2.4-2.4z"
                fill="#f7f7f7"
            />
            <path
                d="M3.2 30.6h25.1c1.6 0 2.9-1.3 2.9-2.9V11.9l-28 18.7z"
                fill="#ffcd41"
            />
            <path
                d="M.6 12v15.7c0 1.6 1.3 2.9 2.9 2.9h25.1L.6 12z"
                fill="#eda821"
            />
        </SvgIcon>
    );
}

MailOpened.defaultProps = {
    viewBox: '0 0 32 32'
};

export default MailOpened;
